import _Vue from 'vue'

/**
 * 表示用の文字列変換メソッド
 *  原則表示のみに使用し値変換には使用しないこと
 */
export default {
  install(Vue: typeof _Vue): void {
    /**
     * 数値の変換
     */
    const number = {
      /**
       * 数値を全角文字列に変換
       *
       * @param value 変換する数値or文字列
       * @returns 変換後文字列
       */
      toDoubleString: function (value: number | string): string {
        return `${value}`.replace(/[0-9]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
        })
      },
      /**
       * 文字列の数値部分を半角に変換
       *
       * @param value 変換する文字列
       * @returns 変換後文字列
       */
      toHalfString: function (value: string): string {
        return value.replace(/[０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
      },
    }
    /**
     * 文字列の変換
     */
    const string = {
      /**
       * 文字列の英数部分を全角文字列に変換
       *
       * @param value 変換する文字列
       * @returns 変換後文字列
       */
      toDoubleString: function (value: string): string {
        return value.replace(/[a-zA-Z0-9]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
        })
      },
      /**
       * 文字列の英数部分を半角に変換
       *
       * @param value 変換する文字列
       * @returns 変換後文字列
       */
      toHalfString: function (value: string): string {
        return value.replace(/[ａ-ｚＡ-Ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
        })
      },
    }

    Vue.prototype.$convertString = { number, string }
  },
}

/**
 * インターフェース定義
 */
declare module 'vue/types/vue' {
  interface Vue {
    $convertString: {
      number: {
        toDoubleString: (value: number | string) => string
        toHalfString: (value: string) => string
      }
      string: {
        toDoubleString: (value: string) => string
        toHalfString: (value: string) => string
      }
    }
  }
}
